import React from 'react';
import { Form, Select } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import countries from 'i18n-iso-countries';
import i18n from 'i18next';
import Style from './countrySelector.module.css';

const mostSelectedCountries = ['FR', 'BE', 'DE', 'CH', 'GB', 'ES', 'NL', 'IT', 'LU', 'US', 'CA'];

const mostSelectedCountriesCanada = ['CA', 'BE', 'FR'];

function getLocaleData(locale) {
    const language_splitted = locale.split('-');
    return {
        lang: language_splitted[0].toLowerCase(),
        country: language_splitted.length === 2 ? language_splitted[1].toUpperCase() : language_splitted[0].toUpperCase()
    };
}

export function getCountriesOptions(locale) {
    const localeData = getLocaleData(locale);
    if (!localeData.lang) {
        return [];
    }
    let objCountries = countries.getNames(localeData.lang, { select: 'official' });
    let optionsCountries = [];
    let optionsMostSelectedCountries = [];
    for (const [key, value] of Object.entries(objCountries)) {
        const mostSelected = localeData.country === 'CA' ? mostSelectedCountriesCanada : mostSelectedCountries;
        const index = mostSelected.findIndex(i => i === key);
        if (index !== -1) {
            optionsMostSelectedCountries[index] = {
                key: key,
                text: value,
                value: key
            };
        } else {
            optionsCountries.push({
                key: key,
                text: key === 'TR' ? 'Türkiye' : value,
                value: key
            });
        }
    }

    optionsCountries.sort((a, b) => {
        if (a.text > b.text) {
            return 1;
        }
        if (a.text < b.text) {
            return -1;
        }
        return 0;
    });

    //@Todo Push divider, improve in Nacre, allow pass key className dropdownItem
    optionsMostSelectedCountries.push({
        key: null,
        text: null,
        value: null,
        disabled: true
    });

    return [...optionsMostSelectedCountries, ...optionsCountries];
}

export default function CountrySelector({ className = null, placeholder = '', value = null, onChange = () => {}, disabled = false }) {
    const locale = i18n.accountLocale;

    const countriesOptions = React.useMemo(() => {
        return getCountriesOptions(locale);
    }, [locale]);

    const [filteredOptions, setOptions] = React.useState(countriesOptions);

    const _onChange = React.useCallback(
        value => {
            onChange(value);
            //reset options,because search props
            setOptions(countriesOptions);
        },
        [countriesOptions, onChange]
    );

    const onInputChange = React.useCallback(
        ({ target: { value } }) => {
            if (!value) {
                return setOptions(countriesOptions);
            }

            const filtered = countriesOptions.filter(({ text }) => {
                const reg = new RegExp(value, 'gi');
                return reg.test(text);
            });

            setOptions(filtered);
        },
        [countriesOptions]
    );

    return (
        <Select
            search
            useNew
            className={`${className}`}
            classNameList={`${Style['select_country__list']}`}
            onClear={() => onChange(null)}
            onChange={_onChange}
            onInputChange={onInputChange}
            options={filteredOptions}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
        />
    );
}

CountrySelector.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.node,
    disabled: PropTypes.bool,
    className: PropTypes.string
};

export function CountrySelectorLabel({ className = null, label = null, optionalText = null, ...rest }) {
    return (
        <Form.Field className={className}>
            <Form.Label label={label} optionalText={optionalText} />
            <CountrySelector {...rest} />
        </Form.Field>
    );
}

CountrySelectorLabel.propTypes = {
    label: PropTypes.string,
    optionalText: PropTypes.string,
    className: PropTypes.string
};
